<template>
	<svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M17.6498 6.35C16.8116 5.50426 15.7942 4.85761 14.6726 4.45779C13.551 4.05796 12.3539 3.91519 11.1698 4.04C7.49978 4.41 4.47978 7.39 4.06978 11.06C3.51978 15.91 7.26978 20 11.9998 20C13.5099 20 14.989 19.5715 16.2653 18.7643C17.5415 17.9571 18.5626 16.8044 19.2098 15.44C19.5298 14.77 19.0498 14 18.3098 14C17.9398 14 17.5898 14.2 17.4298 14.53C16.8492 15.779 15.8561 16.79 14.6177 17.3928C13.3793 17.9956 11.971 18.1536 10.6298 17.84C8.40978 17.35 6.61978 15.54 6.14978 13.32C5.95221 12.4423 5.9545 11.5313 6.15647 10.6546C6.35845 9.77786 6.75494 8.95775 7.31663 8.25492C7.87831 7.55209 8.59082 6.98453 9.40145 6.59421C10.2121 6.2039 11.1001 6.00082 11.9998 6C13.6598 6 15.1398 6.69 16.2198 7.78L14.7098 9.29C14.0798 9.92 14.5198 11 15.4098 11H18.9998C19.5498 11 19.9998 10.55 19.9998 10V6.41C19.9998 5.52 18.9198 5.07 18.2898 5.7L17.6498 6.35Z"
			:fill="color" />
	</svg>

</template>

<script>
import { extractValueAndUnit } from '@/utils/iconUtils'

export default {

	name: 'IconRefresh',

	props: {
		sizeMultiplier_prop: {
			type: Number,
			default: 1,
		},

		width_prop: {
			type: String,
			default: '1rem',
		},

		height_prop: {
			type: String,
			default: '1rem',
		},

		color_prop: {
			type: String,
			default: '',
		},
	},

	data() {
		return {
		}
	},

	computed: {
		color() {
			return this.color_prop || getComputedStyle(document.documentElement).getPropertyValue('--color-theme')
		},

		width() {
			const { value, unit } = extractValueAndUnit(this.width_prop)
			return `${value * this.sizeMultiplier_prop}${unit}`
		},

		height() {
			const { value, unit } = extractValueAndUnit(this.height_prop)
			return `${value * this.sizeMultiplier_prop}${unit}`
		},
	},
}
</script>

<style lang="css" scoped></style>